import React from "react";
import { useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

export const LineChart = () => {
  const {
    data_table: { rows, cols } = {},
    data_table,
    options
  } = useSelector((state) => state.bookings.chartData.data);

  if (data_table) {
    return (
      <GoogleChart
        chartName="bookings_chart"
        chartType="LineChart"
        width="1350px"
        height={400}
        rows={rows}
        columns={cols}
        options={options}
        showCurrency={false}
        showAdditionTooltip={false}
      />
    );
  }
  return null;
};
